import axiosInstance from "../../api/axiosInstance";

export const fetchDashboardSquadsAPI = async ({ query, page, limit }) => {
  const params = new URLSearchParams();
  params.set("query", query || "");
  params.set("page", String(page || 1));
  params.set("limit", String(limit || 10));

  const response = await axiosInstance.get(
    `squads/dashboard-search-for-squad?${params.toString()}`,
  );

  return response.data;
};

export const deleteSquadAPI = async (id) => {
  const response = await axiosInstance.delete(`squads/delete-squad/${id}`);
  return response.data;
};

export const updateSquadAPI = async (id, squadData) => {
  const response = await axiosInstance.put(`squads/update-squad/${id}`, squadData);
  return response.data;
};
